import React, { Component } from "react";
import { service, actions } from "./data";
import { injectIntl, IntlShape } from "@ai360/core/intl";
import { withCrud, withMasked } from "~/hocs";
import { DataTable } from "~/core";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";
import { messages } from "../../i18n-messages";

interface IGrowthStageLogProps {
    records?: Record<string, unknown>[];
    intl: IntlShape;
}

export class GrowthStageLog_ extends Component<IGrowthStageLogProps> {
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render(): JSX.Element {
        return (
            <DataTable
                service={service}
                isCheckbox={false}
                showFilterInput={false}
                messages={messages}
                {...this.props}
                records={this.getFormattedRecords(this.props.records)}
            />
        );
    }
}
export const GrowthStageLog = injectIntl(withMasked(withCrud(GrowthStageLog_, service, actions)));
